import { contactSubTitleRenderer } from './components/subTitleRenderers/contactSubTitleRenderer';
import { conversationHistorySubTitleRenderer } from './components/subTitleRenderers/conversationHistorySubtitleRenderer';
import { conversationTimelineSubTitleRenderer } from './components/subTitleRenderers/conversationTimelineSubTitleRenderer';
import { defaultSubTitleRenderer } from './components/subTitleRenderers/defaultSubTitleRenderer';
import { sideConversationSubTitleRenderer } from './components/subTitleRenderers/sideConversationSubTitleRenderer';
import { sidebarSubTitleRenderer } from './components/subTitleRenderers/sidebarSubTitleRenderer';
import { teamConversationSubTitleRenderer } from './components/subTitleRenderers/teamConversationSubTitleRenderer';
import { ConversationDetailsProps } from './conversationDetails';
import { ConversationDetailsLayout } from './conversationDetailsLayout';

export type SubTitleRendererParams = ConversationDetailsProps;

export const subTitleRenderers: Record<
  ConversationDetailsLayout,
  (props: ConversationDetailsProps) => React.ReactNode | React.ReactNodeArray
> = {
  Overview: defaultSubTitleRenderer,
  Search: defaultSubTitleRenderer,
  Sidebar: sidebarSubTitleRenderer,
  SidebarCollapsed: sidebarSubTitleRenderer,
  SideConversation: sideConversationSubTitleRenderer,
  ConversationHistory: conversationHistorySubTitleRenderer,
  TeamConversation: teamConversationSubTitleRenderer,
  ConversationTimeline: conversationTimelineSubTitleRenderer,
  Contact: contactSubTitleRenderer,
};
